import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'Teranet-PageTitle',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {

  constructor() { }
  @Input() PageTitle: string;
  ngOnInit(): void { }
}
